import { Button, Grid } from "@mui/material";
import * as Yup from 'yup';

import { ReactHookForm } from "../../../../components/hook-form/react-hook-form.component";
import { useReactHookForm } from "../../../../hooks/useReactHookForm";
import { AdHocFormComponent } from "./ad-hoc.form.component";
import { workOrdersApiKeyStore } from "../../../../api/workorders-api-key-store";
import { useSaveData } from "../../../../hooks/useSaveData";

interface DuxAdHocComponent {
    workOrderID: any;
    onDuxCall: () => void;
    onClosed: () => void;
}

const noteValidationSchema = Yup.object().shape({
    name: Yup.object()
        .shape({
            name: Yup.string()
                .nullable()
                .required('Name is required')
                .test('not-zero', 'Name is required', (value) => value !== '' && value !== '0'),
        })
        .required('Name is required'),
    cellPhone: Yup.string().required('Cell Phone is required'),
});

export const DuxAdHocComponent = ({ workOrderID, onDuxCall, onClosed }: DuxAdHocComponent) => {

    const { isLoading, mutateAsync } = useSaveData(workOrdersApiKeyStore.workOrderDuxSMS());

    const form = useReactHookForm({
        defaultValues: {
            name: null,
            cellPhone: ''
        },
        yupSchema: noteValidationSchema
    });

    const handleSubmit = async (hocData: any) => {
        const payload = {
            adHocContactID: hocData?.name?.adHocContactID !== 0 ? hocData?.name?.adHocContactID : null,
            name: hocData?.name?.name ?? '',
            cellPhone: hocData?.cellPhone ?? '',
            workOrderID: workOrderID ?? '',
            Section: 'adhoc'
        };
        // Call SMS API and get response
        const smsResponse = await mutateAsync({ data: payload });
        console.log(smsResponse);
        // Cast data to any to silence TS errors for dynamic keys
        const data: any = smsResponse?.data;
        const duxAdHocCallGuid = data?.duxAdHocCallGuid;
        const returnedWorkOrderID = data?.workOrderID;
        
        // Call Azure Function with query params if both values exist
        try {
            const functionUrl = process.env.REACT_APP_DUX_ADHOC_CALL_URL;
            if (functionUrl && duxAdHocCallGuid && returnedWorkOrderID) {
                const url = `${functionUrl}&DuxAdHocCallGuid=${encodeURIComponent(duxAdHocCallGuid)}&WorkOrderID=${encodeURIComponent(returnedWorkOrderID)}`;
                await fetch(url, { method: 'POST' });
            }
        } catch (err) {
            console.error('Azure Function call failed', err);
        }
        onDuxCall();
    };

    return (
        <ReactHookForm formName="SAVE_AD_HOC_FORM" onSubmit={handleSubmit} formContextProps={form}>
            <Grid container spacing={2} style={{ paddingTop: 10 }}>
                <Grid style={{ height: 180 }} item lg={12} sm={12} xl={12} xs={12}>
                    <AdHocFormComponent />
                </Grid>
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                    <div className="spaceBetween">
                        <Button style={{ width: '130px' }} type="button" variant="outlined" fullWidth onClick={onClosed}>
                            Cancel
                        </Button>
                        <Button
                            type="button"
                            style={{ width: '180px' }}
                            variant="contained"
                            fullWidth
                            disabled={isLoading}
                            onClick={() => form.handleSubmit(handleSubmit)()}>
                            SEND DUX SMS
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </ReactHookForm>
    );
}